import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const PADRAO = "Bonificação de Metas";

// O nome é configurável (cada empresa chama de um jeito) e aparece no menu de
// toda página: guarda em memória para não buscar a cada navegação.
let cache: string | null = null;
let pendente: Promise<string> | null = null;
const ouvintes = new Set<(nome: string) => void>();

function buscar(): Promise<string> {
  pendente ??= api
    .get<{ nome: string }>("/bonificacoes/nome")
    .then((r) => (cache = r.nome || PADRAO))
    .catch(() => PADRAO)
    .finally(() => {
      pendente = null;
    });
  return pendente;
}

/** Depois de renomear em Configurações, atualiza o menu sem recarregar a página. */
export function definirNomeBonificacao(nome: string) {
  cache = nome;
  ouvintes.forEach((f) => f(nome));
}

/** Nome da bonificação de metas desta empresa (ex.: "Múltiplos de Salário"). */
export function useNomeBonificacao(): string {
  const [nome, setNome] = useState(cache ?? PADRAO);
  useEffect(() => {
    ouvintes.add(setNome);
    if (cache === null) void buscar().then(setNome);
    return () => {
      ouvintes.delete(setNome);
    };
  }, []);
  return nome;
}
